import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';
import { cn } from '@simplywallst/ui-core/next';

type Props = {
  title: string;
  subtitle: string;
  html: string;
  onClick: (html: string) => void;
};

const baseClasses = cn([
  'relative',
  'overflow-hidden',
  'text-left',
  'transition-colors',
  'border',
  'border-solid',
  'p-x1',
  'rounded-x1',
  'bg-p-grey-50',
  'border-p-white-100/5',
  'focus-within:bg-p-grey-30',
  'focus:bg-p-grey-30',
  'hover:bg-p-grey-30',
  'focus:outline-dashed',
  'focus:outline-1',
  'focus:outline-solid',
  'focus:outline-offset-[3px]',
  'focus:outline-p-blue-100',
  'group',
]);

const plusButtonWrapperClasses = cn([
  'inset-0',
  'left-1/2',
  'absolute',
  'p-x2',
  'grid',
  'justify-end',
  'items-center',
  'transition-all',
  'opacity-0',
  'bg-gradient-to-r',
  'from-p-grey-50/0',
  'via-25%',
  'to-p-grey-50',
  'group-hover:opacity-100',
  'group-focus:opacity-100',
  'group-focus-within:opacity-100',
]);

export const NarrativeEditorSuggestionItem = ({
  title,
  subtitle,
  html,
  onClick,
}: Props) => {
  return (
    <button onClick={() => onClick(html)} className={baseClasses}>
      <div className="grid grid-cols-1">
        <div>
          <div className="text-sm font-strong text-solid">{title}</div>
          <div className="line-clamp-1 text-xs text-soft">{subtitle}</div>
        </div>

        <div className={plusButtonWrapperClasses}>
          <div className="border rounded-x1 border-solid border-p-white-100/5 px-x0_5 py-[3px]">
            <PlusSolid className="fill-softer" />
          </div>
        </div>
      </div>
    </button>
  );
};
